import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  LinearProgress,
  Paper,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import LinkIcon from "@material-ui/icons/Link";
import { Edit, Delete } from "@material-ui/icons";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline";
import StopOutlinedIcon from "@material-ui/icons/StopOutlined";
import { ListSubAssetView } from "./ListSubAssetView";
import UpdateIcon from "@material-ui/icons/Update";
import { EditLinkAssetDialog } from "./EditLinkAssetDialog";
import { LinkAssetConfirmDialog } from "./LinkAssetConfirmDialog";
import { useSubAssetLinkedView } from "../stressEntry/stressEntryQueries";
import { formatDate } from "../../../common/formatDate";

export const ListSubAsset = () => {
  const [expandedId, setExpandedId] = useState<number | null>(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false);
  const [selectedAsset, setSelectedAsset] = useState<any | null>(null);

  const {
    error: errorAssetTypes,
    data: assets,
    isLoading: isLoadingAssets,
    isError: isErrorAssets,
  } = useSubAssetLinkedView();

  

  const handleEditDialogOpen = (asset: any) => {
    setOpenDialog(true);
    setSelectedAsset(asset);
  };

  const handleRemoveDialogOpen = (asset: any) => {
    setOpenRemoveDialog(true);
    setSelectedAsset(asset);
  };

  if (isLoadingAssets) {
    return <LinearProgress />;
  }

  return (
    <>
      <Grid>
        {assets.map((asset: any) => {
          const isExpanded = expandedId === asset.id;
          return (
            <Paper style={{ padding: "20px", marginTop: "10px" }}>
              <Grid container alignItems="center" spacing={2}>
                <Grid item>
                  <IconButton
                    size="small"
                    onClick={() => setExpandedId(isExpanded ? null : asset.id)}
                  >
                    {isExpanded ? (
                      <KeyboardArrowUpIcon />
                    ) : (
                      <KeyboardArrowDownIcon />
                    )}
                  </IconButton>
                </Grid>

                <Grid item>
                  <LinkIcon style={{ color: "#800280" }} />
                </Grid>

                <Grid item xs style={{ textAlign: "left" }}>
                  <Grid style={{ display: "flex", alignItems: "center" }}>
                    <Typography
                      variant="subtitle1"
                      style={{ color: "#800280", fontSize: "16px" }}
                    >
                      {asset?.asset_name ? asset?.asset_name : "N/A"}
                    </Typography>
                    {asset.inUse ? (
                      <Box
                        style={{
                          backgroundColor: "#FEF3F2",
                          padding: "3px 8px",
                          border: "1px solid #FFCACA",
                          borderRadius: "100px",
                          fontSize: "13px",
                          display: "flex",
                          alignItems: "center",
                          marginLeft: "5px",
                          color: "#FF0000",
                        }}
                      >
                        <PlayCircleOutlineIcon
                          style={{ fontSize: 14, marginRight: 4 }}
                        />
                        {"in use"}
                      </Box>
                    ) : (
                      <Box
                        style={{
                          backgroundColor: "#EFFDF4",
                          padding: "3px 8px",
                          border: "1px solid #B9F8CF",
                          borderRadius: "100px",
                          fontSize: "13px",
                          display: "flex",
                          alignItems: "center",
                          color: "#008000",
                          marginLeft: "5px",
                        }}
                      >
                        <img
                          src="/Icon_Available_Status.svg"
                          alt="status icon"
                          style={{ width: 14, height: 14, marginRight: 4 }}
                        />
                        {"avaliable"}
                      </Box>
                    )}
                  </Grid>

                  <Typography
                    variant="body2"
                    style={{ color: "#0000008A", fontSize: "12px" }}
                  >
                    {asset?.linkedsubassets ? asset?.linkedsubassets : "0"}{" "}
                    linked sub-assets Linked on{" "}
                    {asset?.linked_date
                      ? formatDate(asset?.linked_date)
                      : "N/A"}
                  </Typography>
                </Grid>

                <Grid item>
                  <Button
                    variant="contained"
                    style={{ backgroundColor: "#FFFFFF" }}
                    disabled={asset.inUse}
                    onClick={() => handleEditDialogOpen(asset)}
                  >
                    <Edit color={asset.inUse ? "disabled" : "primary"} />
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    style={{ backgroundColor: "#FFFFFF" }}
                    disabled={asset.inUse}
                    onClick={() => handleRemoveDialogOpen(asset)}
                  >
                    <Delete
                      style={{ color: asset.inUse ? "disabled" : "#F50057" }}
                    />
                  </Button>
                </Grid>
              </Grid>

              {isExpanded && (
                <ListSubAssetView asset_id={expandedId} data={asset} />
              )}
            </Paper>
          );
        })}
      </Grid>

      {openDialog && (
        <EditLinkAssetDialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          asset={selectedAsset}
        />
      )}

      {openRemoveDialog && (
        <LinkAssetConfirmDialog
          open={openRemoveDialog}
          onClose={() => setOpenRemoveDialog(false)}
          mode="remove"
          asset={selectedAsset}
        />
      )}
    </>
  );
};
